import bahtText from 'thai-baht-text';
import React from 'react';
//import './receiptPrint.css';

// --- สร้าง Sub-component เพื่อ render ใบเสร็จหนึ่งใบ ---
//    รับ props สำหรับข้อมูลและ "หัวข้อ" ของใบเสร็จ
const SingleReceipt = ({ receiptData, title }) => {
  // แปลงค่าที่รับมาให้เป็น String และลบเครื่องหมาย comma (,) ออกก่อน
  const amountValue = parseFloat(String(receiptData['จำนวนเงิน'] || '0').replace(/,/g, ''));
  // สร้างตัวแปรสำหรับตรวจสอบว่าค่าที่แปลงมานั้น เป็นตัวเลขที่ถูกต้องหรือไม่
  const isValidAmount = !isNaN(amountValue);

  const formatDateToThai = (isoDateString) => {
    if (!isoDateString) return '';
    const date = new Date(isoDateString);
    const day = date.getDate();
    const monthNamesThai = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const month = monthNamesThai[date.getMonth()];
    const year = date.getFullYear() + 543;
    return `${day} ${month} ${String(year).slice(-2)}`;
  };

  const tab1 = '\u00a0\u00a0\u00a0\u00a0\u00a0'; // 1 Tab
  const tab2 = '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'; // 2 TABs
  const tab3 = '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0';
  const indentForNotes = tab2 + '\u00a0\u00a0\u00a0'; // 2 TABs + 3 spaces

  return (
    <div className="receipt-print-container school-receipt-print">
      {/* Header Section */}
      <div className="receipt-header">
        <div className="receipt-address">
          <p>สถาบันพาวร์เวอร์วิสดอม</p>
          <p>32/514 ถ.ประชาอุทิศ แขวงทุ่งครุ เขตทุ่งครุ</p>
          <p>กรุงเทพฯ 10140 โทร. 093-2293959</p>
          <p><a href="https://www.power-wisdom.com">www.power-wisdom.com</a></p>
        </div>
        <div className="receipt-logo">
          <img src="/Wisdom-Logo.png" alt="Power Wisdom Logo" style={{ height: '50px' }} />
        </div>
      </div>

      {/* Title and Receipt Info Section */}
      <div className="receipt-title-row">
        {/* ใช้ title จาก props ที่ส่งเข้ามา */}
        <p className="receipt-title-school">{title}</p>
        <div className="receipt-info-box-school">
          <div className="info-row">
            <span>เลขที่</span>
            <span className="info-value">{receiptData['เลขที่']}</span>
          </div>
          <div className="info-row">
            <span>วันที่</span>
            <span className="info-value">{formatDateToThai(receiptData['วันที่'])}</span>
          </div>
        </div>
      </div>

      {/* Section for "ได้รับเงินจาก" */}
      <div className="receipt-details school-details">
        <div className="detail-row">
          <span className="label">ได้รับเงินจาก</span>
          <span className="value">{receiptData['โรงเรียน']}</span>
        </div>
      </div>

      {/* Table for items and amounts */}
      <table className="receipt-table">
        <thead>
          <tr>
            <th style={{ width: '80%' }}>รายการ</th>
            <th style={{ width: '20%' }}>จำนวนเงิน</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>{tab1}{receiptData['ประเภท']}</p>
              <p>{tab3}{receiptData['หลักสูตร']}{tab1}งวดที่ : {receiptData['งวดที่']}</p>
              <p>{tab3}{receiptData['ภาคเรียน']}</p>
              <p> </p>
            </td>
            <td className="amount">
              {isValidAmount ? amountValue.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
            </td>
          </tr>
          <tr className="total-word-row">
            <td colSpan="1" className="total-label">
              {isValidAmount ? bahtText(amountValue) : ''}
            </td>
            <td className="amount total">
              {isValidAmount ? amountValue.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Footer Section */}
      <div className="receipt-footer school-footer">
        <div className="payment-info">
          <p>
            <span className="payment-label">วิธีการชำระ</span>
            {tab2}{receiptData['วิธีการชำระ']}
          </p>
        </div>
        <div className="footer-notes">
          <p>
            <span className="note-label">หมายเหตุ</span>
            {indentForNotes}{receiptData['หมายเหตุ']}
          </p>
        </div>

        <div className="recipient-signature">
          <p>ผู้รับเงิน ..............................................................</p>
          <p>(นางปรัชภา อภิวุฒิกาญจนาภา){tab2}</p>
        </div>

        <div className="receipt-validation-box">
          <p className="validation-text-top">ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์ถูกต้องต่อเมื่อเรียกเก็บเงินตามเช็คได้เรียบร้อยและต้องมีลายเซ็นต์</p>
          <p className="validation-text-bottom">ของผู้มีอำนาจในการรับเงินและลงตราประทับของสถาบันพาวร์เวอร์วิสดอมเท่านั้น</p>
        </div>
      </div>
    </div>
  );
};


// --- Component หลักที่ Export ออกไป ---
const SchoolReceiptPrint = ({ receiptData }) => {
  if (!receiptData) return null;

  return (
    <>
      {/* Render ใบเสร็จต้นฉบับ */}
      <SingleReceipt receiptData={receiptData} title="ใบเสร็จรับเงิน" />
      {/* Render ใบเสร็จสำเนา */}
      <SingleReceipt receiptData={receiptData} title="ใบเสร็จรับเงิน/สำเนา" />
    </>
  );
};

export default SchoolReceiptPrint;